import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { CardDetails, CardSummary } from "./cards";

// 1️⃣ Fetch all cards (for tabs)
export const fetchCardsList = createAsyncThunk<CardSummary[], { type?: string[] }>(
  "cards/fetchCardsList",
  async (queryParams, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("viart_token");

      const res = await axios.get<{ cards: CardSummary[] }>(
        `${process.env.REACT_APP_BACKEND_URL}/api/dashboard/cards`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: queryParams,
        }
      );

      return res.data.cards;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || "Failed to load cards");
    }
  }
);

// 2️⃣ Fetch single card details
export const fetchCardDetails = createAsyncThunk<CardDetails, string>(
  "cards/fetchCardDetails",
  async (cardId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('viart_token');

      const res = await axios.get<CardDetails>(`${process.env.REACT_APP_BACKEND_URL}/api/dashboard/cards/${cardId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || "Failed to load card details");
    }
  }
);

interface CreateCardResult {
  card: CardSummary;
  cardCount: number;
  employeeCount: number;
}

// 3️⃣ Create a new card with a random link
export const createCardWithLink = createAsyncThunk<CreateCardResult, void>(
  "cards/createCardWithLink",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("viart_token");

      const res = await axios.post<CreateCardResult>(
        `${process.env.REACT_APP_BACKEND_URL}/api/dashboard/cards`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || "Failed to create link");
    }
  }
);

// 4️⃣ Create a new employee card
export const createEmployeeCard = createAsyncThunk<CreateCardResult, void>(
  "cards/createEmployeeCard",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("viart_token");

      const res = await axios.post<CreateCardResult>(
        `${process.env.REACT_APP_BACKEND_URL}/api/dashboard/cards`,
        { cardType: 'employee' },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || "Failed to create employee card");
    }
  }
);
